<template>
    <div>
        <b-field
            expanded
            class="required"
            label="Название"
            :message="errors.first('title')"
            :type="errors.has('title') ? 'is-danger' : ''">
            <textarea-autosize
                rows="1"
                class="textarea"
                maxlength="500"
                v-model.trim="item.title"/>
        </b-field>

        <b-field label="Описание">
            <textarea-autosize
                rows="1"
                class="textarea"
                maxlength="2000"
                v-model.trim="item.description"/>
        </b-field>
        
        <div class="columns">
          <div class="column">
            <b-field label="Участники" class="required">
                <div class="columns">
                    <div v-if="item.is_quiz" class="column is-4 is-flex">
                        <b-field expanded style="align-self: center; width: 100%">
                            <b-radio-button
                                @input="onScopeTypeUpdate"
                                v-model="scopeTypeInternal"
                                class="is-expanded"
                                native-value="agenda">
                                <span>Мои группы</span>
                            </b-radio-button>
                            <b-radio-button
                                @input="onScopeTypeUpdate"
                                v-model="scopeTypeInternal"
                                class="is-expanded"
                                native-value="shared">
                                <span>Все группы</span>
                            </b-radio-button>
                            <b-radio-button
                                @input="onScopeTypeUpdate"
                                v-model="scopeTypeInternal"
                                class="is-expanded"
                                native-value="aggregate">
                                <span>Потоки</span>
                            </b-radio-button>
                        </b-field>
                    </div>
                    <div v-else class="column is-5 is-flex">
                        <b-field expanded style="align-self: center; width: 100%">
                            <b-radio-button
                                @input="onScopeTypeUpdate"
                                v-model="scopeTypeInternal"
                                class="is-expanded"
                                native-value="employee">
                                <span>Сотрудники</span>
                            </b-radio-button>
                            <b-radio-button
                                @input="onScopeTypeUpdate"
                                v-model="scopeTypeInternal"
                                class="is-expanded"
                                native-value="aggregate">
                                <span>Студенты</span>
                            </b-radio-button>
                        </b-field>
                    </div>
                    <div class="column">
                        <b-taginput
                            @input="e => { onUpdate(e); scopeModified = true }"
                            v-model="item.scope"
                            :data="filteredScopes"
                            open-on-focus
                            autocomplete
                            field="title"
                            :placeholder="ScopePlaceholder"
                            @typing="getFilteredScopes">
                        </b-taginput>
                    </div>
                </div>
            </b-field>
          </div>
          <div class="column is-one-quarter" v-if="!item.is_quiz">
            <b-field label="Автоматические вопросы">
                <b-select
                  expanded
                  :disabled="item.published == true"
                  class="taginput-sibling"
                  v-model="item.generate_questions">
                    <option :value="null">Нет</option>
                    <option
                        v-for="option in generateQuestionOptions"
                        :value="option.value"
                        :key="option.value">
                        {{ option.title }}
                    </option>
                </b-select>
            </b-field>
          </div>
        </div>

        <div class="columns has-text-centered"
            v-if="item.is_quiz">
            <div class="column">
                <b-field label="Ограничение по времени">
                    <b-switch
                        v-model="hasDuration">
                    </b-switch>
                </b-field>
            </div>
            <div class="column">
                <b-field label="Время на тест (в минутах)">
                    <b-input
                        :disabled="!hasDuration"
                        :placeholder="item.is_quiz ? 'На время выполнения' : 'Неограниченно'"
                        type="number"
                        min="5"
                        max="43200"
                        @input="onUpdate"
                        v-model="item.duration">
                    </b-input>
                </b-field>
            </div>
        </div>
        
        <b-field
            v-if="item.is_quiz"
            label="Тип оценки ответов">
            <b-select
                v-model="item.score_type"
                expanded>
                <option value="points">Баллы (от 0 до 10)</option>
                <option value="binary">Двоичная (правильно / неправильно)</option>
            </b-select>
        </b-field>

        <div class="columns" v-if="item.is_quiz">
            <div class="column">
                <b-field
                    label="Предоставить доступ пользователям"
                    message="У выбранных пользователей будет полный доступ к данному тесту (включая публикацию и удаление) и его результам"
                >
                    <user-list-input
                        type="is-primary"
                        icon="account-plus"
                        placeholder="Введите ФИО преподавателя для поиска"
                        :ignore-ids="[ item.author.id ]"
                        v-model="item.shares"
                        :filter="{
                            type: 'employee',
                        }"
                    ></user-list-input>
                </b-field>
            </div>
        </div>

        <br>

        <b-field>
            <button class="button is-success is-outlined is-fullwidth"
                @click="$emit('submit', scopeModified)">
                Сохранить
            </button>
        </b-field>

        <template v-if="item.generate_questions == null">

          <template v-if="questions.length && !item.published">
              <hr>
          </template>

          <template v-if="item.published">
              
              <div class="message is-danger">
                  <div class="message-body">
                    <div class="media">
                      <div class="media-left">
                        <span class="icon is-large is-info">
                          <i class="mdi mdi-alert-circle mdi-48px"></i>
                        </span>
                      </div>
                      <div class="media-content">
                        <template v-if="item.is_quiz">Данный тест опубликован &ndash; </template>
                        <template v-else>Данная анкета опубликована &ndash; </template>
                        добавление новых и удаление существующих вопросов недоступно.
                        <br>
                        Для того, чтобы иметь возможность полностью редактировать вопросы, необходимо
                        <a :href="item.url">
                            скрыть
                            <template v-if="item.is_quiz">тест.</template>
                            <template v-else>анкету.</template>
                        </a>
                        <template v-if="!questionsAreVisible">
                            <br><br>
                            Вы можете изменить текст вопросов,
                            а также правильные варианты ответов, включив
                            <i>ограниченный режим редактирования</i>,
                            нажав на кнопку ниже.
                            <br>
                        </template>
                      </div>
                    </div>
                  </div>
              </div>

              <template v-if="!questionsAreVisible">
                <p class="has-text-centered">
                    <button class="button is-danger is-outlined" @click="enableRestrictedMode">
                        Включить ограниченный режим редактирования
                    </button>
                </p>

                <br>
              </template>

          </template>

          <draggable v-model='questions'
              @end="questionDragEnd"
              v-show="questionsAreVisible"
              :options="draggableOptions">
              <question
                  :survey="item"
                  @created="questionCreated"
                  @remove="removeQuestion"
                  @duplicate="duplicateQuestion"
                  v-for="question in questions"
                  :value="question"
                  :key="question.uuid"
              />
          </draggable>

          <div class="section" v-if="!item.published">
              <div class="field">
                  <p class="control is-expanded">
                      <button
                          @click="addQuestion"
                          class="button is-outlined is-fullwidth">
                          <b-icon icon="plus" size="is-small"></b-icon>
                          <span>Добавить вопрос</span>
                      </button>
                  </p>
              </div>
          </div>

        </template>

        <template v-else-if="item.generate_questions == 'teacher-rating'">

          <hr>

          <div class="message">
            <div class="message-body has-text-centered">
              Вопросы будут сгенерированы автоматически для каждого студента
            </div>
          </div>
        
        </template>
    </div>
</template>

<script>
import ModelForm from "./ModelForm";
import toasts from "../../mixins/toasts";
import scopeTitle from "../../mixins/survey/scopeTitle";
import UserListInput from "../../../components/UserListInput";
import Question from "../../survey/Question";
import Draggable from "vuedraggable";

export default ModelForm.extend({
  props: {
    preset: {
      type: Object
    },
    scopes: {
      type: Array,
      default: []
    }
  },
  mixins: [toasts, scopeTitle],
  components: { Question, Draggable, UserListInput },
  data() {
    return {
      scopeModified: false,
      hasDuration: false,
      draggableOptions: {
        handle: ".handle"
      },
      questions: [],
      item: {},
      filteredScopes: [],
      scopeType: null,
      scopeTypeInternal: null,
      restrictedModeConfirmed: false,
    };
  },
  watch: {
    hasDuration(value) {
      if (value && !this.item.duration) {
        this.item.duration = 15;
      } else if (!value) {
        this.item.duration = null;
      }
    },
    item: {
      deep: true,
      handler: "onUpdate"
    }
  },
  computed: {
    questionsAreVisible() {
        return !this.item.published || this.restrictedModeConfirmed;
    },
    generateQuestionOptions() {
      return [
        {
          value: 'teacher-rating',
          title: 'Оценка качества преподавания',
        }
      ];
    },
    ScopePlaceholder() {
      let title = _.get(_.first(this.scopes.filter(this.checkScopeType)), "title");
      return title ? `Например: ${title}` : "Нет занятий в расписании";
    }
  },
  created() {
    if (this.preset) {
      if (this.preset.is_quiz && !this.preset.score_type) {
        this.preset.score_type = "points";
      }

      let type = 'aggregate'

      if (this.preset.scope.length > 0) {
            this.preset.scope = this.preset.scope.filter(scope => {
                return scope != undefined
            })

            if (this.preset.scope.length > 0) {
                type = _.get(_.first(this.preset.scope), 'type')
            }
      } else {
        if (_.find(this.scopes, {type: 'agenda'}) != null) {
          type = 'agenda'
        } else if (_.find(this.scopes, {type: 'shared'}) != null) {
          type = 'shared'
        }
      }

      this.scopeType = this.scopeTypeInternal = type

      this.update(this.preset);
    }

    let loading = this.$loading.open();

    axios
      .get(`/api/surveys/${this.item.id}/questions`)
      .then(response => {
        this.questions = response.data;
      })
      .catch(error => {
        this.toast("error", "@unexpected", error);
      })
      .finally(_ => {
        loading.close();
        this.getFilteredScopes('');
      });
  },
  methods: {
    enableRestrictedMode() {
        this.$dialog.confirm({
            title: "",
            message:
                `Вы собираетесь включить ограниченный режим редактирования вопросов.<br>` +
                `Вы сможете изменять <b>правильные варианты ответов</b> и <b>порядок вопросов</b>.<br>` +
                `В случае изменения правильных вариантов ответов баллы за тест у студентов, ` +
                `которые уже его прошли <b>будут пересчитаны</b>.`,
            confirmText: "Продолжить",
            cancelText: "Отмена",
            type: "is-danger",
            hasIcon: true,
            onConfirm: () => {
                this.restrictedModeConfirmed = true;
            }
        });
    },
    removeQuestion(question) {
      let loading = this.$loading.open();

      axios
        .delete(`/api/surveys/${this.item.id}/questions/${question.uuid}`)
        .then(response => {
          this.questions.splice(
            _.findIndex(this.questions, {
              uuid: question.uuid
            }),
            1
          );
        })
        .catch(error => {
          this.toast("error", "@unexpected", error);
        })
        .finally(_ => {
          loading.close();
        });
    },
    questionCreated() {
      // Refresh list keys to apply newly generated uuid
      this.$forceUpdate();
    },
    duplicateQuestion(question) {
      let index =
        _.findIndex(this.questions, {
          uuid: question.uuid
        }) + 1;

      if (index > -1) {
        let data = _.merge(_.omit(question, "uuid"), {
          index: index
        });

        this.questions.splice(index, 0, data);
      }
    },
    addQuestion() {
      this.questions.push({
        type: "radio",
        required: false,
        options: []
      });
    },
    questionDragEnd(e) {
      e.item.__vue__.update({
        index: e.newIndex
      });
    },
    onScopeTypeUpdate(type) {
        if(this.item.scope.length > 0) {
            this.$dialog.confirm({
            title: "Смена типа участников",
            message:
                `Вы собираетесь сменить тип участников.<br>` +
                `Список участников будет очищен.`,
            confirmText: "Продолжить",
            cancelText: "Отмена",
            type: "is-info",
            hasIcon: true,
            onConfirm: () => {
                this.scopeType = this.scopeTypeInternal
                this.filteredScopes = []
                this.item.scope = []
                this.getFilteredScopes('')
            },
            onCancel: () => {
                this.scopeTypeInternal = this.scopeType
            }
            });
        } else {
            this.scopeType = this.scopeTypeInternal
            this.filteredScopes = []
            this.getFilteredScopes('')
        }
    },
    checkScopeType(scope) {
        if (this.item.is_quiz) {
            return this.scopeType == scope.type
        } else {
            return this.scopeTypeInternal == 'employee' && scope.type == 'employee'
              || this.scopeTypeInternal != 'employee' && scope.type != 'employee';
        }
    },
    getFilteredScopes(text) {
      this.filteredScopes = this.scopes.filter(option => {
        return (
          this.checkScopeType(option) &&
          option.title &&
          option.title
            .toString()
            .toLowerCase()
            .indexOf(text.toLowerCase()) >= 0
        );
      });
    },
    update(item) {
      if (this.scopes.length) {
        item.scope = this.$_.map(item.scope, item => {
          if (item && item.scope) {
            return item;
          }

          return this.$_.find(this.scopes, {
            scope: item
          });
        });
      }

      this.item = _.clone(item);

      this.hasDuration = this.item.has_duration;
    },
    onUpdate() {
      let item = _.clone(this.item);

      item.scope = this.$_.map(item.scope, "scope");

      if (item.duration == 0) {
        item.duration = null;
      }

      this.$emit("update", item);
    }
  }
});
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/models/Survey.vue